/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createProblemDetailsFromDiscriminatorValue, type ProblemDetails } from '../../../models';
// @ts-ignore
import { type BaseRequestBuilder, type DateOnly, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /scheduledtransactions/paid/{scheduledTransactionId}
 */
export interface WithScheduledTransactionItemRequestBuilder extends BaseRequestBuilder<WithScheduledTransactionItemRequestBuilder> {
    /**
     * Confirms a scheduled transaction has been paid, and calculates the next payment date
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<DateOnly>}
     * @throws {ProblemDetails} error when the service returns a 404 status code
     */
     patch(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<DateOnly | undefined>;
    /**
     * Confirms a scheduled transaction has been paid, and calculates the next payment date
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPatchRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const WithScheduledTransactionItemRequestBuilderUriTemplate = "{+baseurl}/scheduledtransactions/paid/{scheduledTransactionId}";
/**
 * Metadata for all the requests in the request builder.
 */
export const WithScheduledTransactionItemRequestBuilderRequestsMetadata: RequestsMetadata = {
    patch: {
        uriTemplate: WithScheduledTransactionItemRequestBuilderUriTemplate,
        responseBodyContentType: "text/plain;q=0.9",
        errorMappings: {
            404: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "sendPrimitive",
        responseBodyFactory:  "DateOnly",
    },
};
/* tslint:enable */
/* eslint-enable */
